import React from 'react'

const TermCondition = () => {
  return (
    <div>
      <div>
            <div className="site-wrap" id="home-section">
                <div
                    style={{
                        backgroundImage:
                            "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)"
                    }}
                >
             
                
                    <div className="site-mobile-menu site-navbar-target mt-4">
                        <div className="site-mobile-menu-header">
                            <div className="site-mobile-menu-close mt-3">
                                <span className="icon-close2 js-menu-toggle" />
                            </div>
                        </div>
                        <div className="site-mobile-menu-body" />
                    </div>
                    <header className="site-navbar site-navbar-target mt-5" role="banner">
                        <div className="container">
                            <div className="row align-items-center position-relative">
                                <div className="col-3 ">
                                    <div className="site-logo">
                                        <a href="index.html">
                                            <img
                                                style={{ width: 150 }}
                                                src="https://i.ibb.co/mGh4f8g/Premium-Car-Rentals-Limited-Logo-Design-1-removebg-preview.png"
                                                alt=""
                                            />
                                        </a>
                                    </div>
                                </div>
                             
                            </div>
                        </div>
                    </header>
                    <div className="ftco-blocks-cover-1">
                        <div className="ftco-cover-1 overlay innerpage">
                            <div className="container">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-lg-6 text-center">
                                        <h1>Terms &amp; Conditions</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section" style={{ backgroundColor: "#dfdaf3" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 offset-md-2">
                                <h2>Payment Policy:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Full payment is required at the time of rental. Accepted payment
                                    methods include credit cards, debit cards, or other methods as
                                    approved by the company.
                                </p>
                                <h2 className="mt-5">Cancellations and Refunds:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Cancellations made 24 hours prior to the rental date are eligible
                                    for a full refund. No-shows or late cancellations may forfeit the
                                    refund.
                                </p>
                                <h2 className="mt-5">Liability:</h2>
                                <p style={{ fontSize: "large" }}>
                                    The renter is liable for any damage to the vehicle caused during the
                                    rental period, including but not limited to accidents, theft, or
                                    negligence, not covered by comprehensive insurance.
                                </p>
                                <h2 className="mt-5">Inspection on Return:</h2>
                                <p style={{ fontSize: "large" }}>
                                    A thorough inspection will be conducted upon the return of the
                                    vehicle. Any damages or missing items will be charged to the renter.
                                </p>
                                <h2 className="mt-5">Jurisdiction:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Any disputes arising from this agreement will be resolved under the
                                    jurisdiction of Tanzania.
                                </p>
                                <p style={{ fontSize: "large" }}>
                                    By signing the rental agreement, you acknowledge that you have read,
                                    understood, and agreed to the above policies and terms &amp;
                                    conditions.
                                </p>
                                <p style={{ fontSize: "large" }}>
                                    For further assistance, please contact our customer service team.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
  )
}

export default TermCondition
